import { subDays, roundToNearestHours, formatISO } from 'date-fns';

import { LayoutGoalReportParams } from '@data';

import { CustomRangeInput, GoalFilters, PeriodFilter, SwingsFilter } from '../../GoalReportContext';

const lastSwingsMap: Record<SwingsFilter, number | null> = {
    all: null,
    last10: 10,
    last20: 20,
    last6: 6,
};

const periodMap: Record<PeriodFilter, number | null> = {
    all: null,
    month: 30,
    week: 7,
    year: 365,
    custom: null,
};

type ConvertFiltersToGoalReportParams = GoalFilters & CustomRangeInput & { layoutId: number };
export const convertFiltersToGoalReportParams = ({
    period,
    swings,
    from,
    to,
    layoutId: layoutId,
}: ConvertFiltersToGoalReportParams): LayoutGoalReportParams => {
    if (swings && lastSwingsMap[swings]) {
        return {
            layoutId: layoutId,
            lastSwings: lastSwingsMap[swings],
        };
    }
    if (period === 'custom' && from && to) {
        const isoFrom = formatISO(from);
        const isoTo = formatISO(to);

        return {
            layoutId: layoutId,
            from: isoFrom,
            to: isoTo,
        };
    }
    if (period && periodMap[period]) {
        return {
            layoutId: layoutId,
            from: createDateString(periodMap[period]),
        };
    }
    return { layoutId: layoutId };
};

const createDateString = (daysInPast: number): string => {
    const today = new Date();
    const past = subDays(today, daysInPast);
    return roundToNearestHours(past).toISOString();
};
